import React from "react";
import Archive from "app/pages/DRM/Archive";
import AuditResult from "app/pages/DRM/AuditResult";
import DataRiskManager from "app/pages/DRM/DataRiskManager";
import DocketsUpload from "app/pages/DRM/DocketsUpload/DocketsUpload";
import Page from "@jumbo/shared/Page";
import Owner from "app/pages/DRM/Owner/owner";
import ActivityCodeManager from "app/pages/DRM/ActivityCodeManager";
import Files from "app/pages/DRM/DocketsUpload/Files";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import { IpProvider } from "./components/IpProvider";
import { Toaster } from "react-hot-toast";
import HelpSection from "./components/help-section/HelpSection";

const DRMRoutes = [
    {
        path: [
            "/drm",
            "/drm/audit-result",
            "/drm/audit-result/:category",
        ],
        element: <TenantAdminRoute element={
            <IpProvider>
                <Page component={AuditResult} />
            </IpProvider>
        } />
    },
    {
        path: [
            "/drm/data-risk-manager"
        ],
        element: <TenantAdminRoute element={
            <IpProvider>
                <Page component={DataRiskManager} />
            </IpProvider>} />
    },
    {
        path: [
            "/drm/file-upload",

        ],
        element: <TenantAdminRoute element={
            <IpProvider>
                <Page component={DocketsUpload} />
                <Toaster />
            </IpProvider>
        } />
    },
    {
        path: [
            "/drm/archive",

        ],
        element: <TenantAdminRoute element={
            <IpProvider>
                <Page component={Archive} />
            </IpProvider>
        } />
    },
    {
        path: [
            "/drm/file-upload/files",
        ],
        element: <TenantAdminRoute element={
            <IpProvider>
                <Page component={Files} />
                <Toaster />
            </IpProvider>

        } />
    },
    {
        path: [
            "/drm/owner",
        ],
        element: <TenantAdminRoute element={<Page component={Owner} />} />
    },
    {
        path: [
            "/drm/activity-code",
        ],
        element: <TenantAdminRoute element={<Page component={ActivityCodeManager} />} />
    },

    ///HELP SECTION
    {
        path: ["/drm/help"],
        element: <TenantAdminRoute element={<Page component={HelpSection} />} />
    },
];

export default DRMRoutes;
